<template>
  <div
    class="map-container"
    style="height: 25vh"
  >
    <map-container
      ref="map"
      :find-user="false"
      @on-drag-end="onDragMarker"
      @on-map-changed="onMapChanged"
      @on-map-clicked="onMapClicked"
    />
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {mapHelper} from '../mixins/MapMixin'
import {vehicleHelper} from "../mixins/VehicleMixin";
import MapContainer from "./MapContainer";
import bridgeSvg from '@/assets/bridge.svg'

export default {
    name: 'MarkerEditorMap',
    components: {MapContainer},
    mixins: [vehicleHelper, timeUtils, mapHelper],
    props: {
        lat: {
            type: Number,
            default: 0
        },
        lon: {
            type: Number,
            default: 0
        },
        type: {
            type: Number,
            default: 0
        },
        vehicleType: {
            type: Number,
            default: 1
        },
        draggable: Boolean,
        observationMode: {
            type: Boolean,
            default: false
        },
        showButtons: {
            type: Boolean,
            default: false
        },
        points: {
            type: Array,
            default: function () {
                return []
            }
        },
        forceRemovePreviousGeometry: {
            type: Boolean,
            default: false
        },
        fresh: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: 0
        }
    },
    watch: {
        lat() {
            this.updatePoint()
        }
    },
    data: function () {
        return {
            icon: null,
            map: null
        }
    },
    methods: {

        onMapChanged(map) {
            if (!map) {
               return
            }
            this.map = this.$refs.map ? this.$refs.map.getMap() : undefined
            this.$nextTick(() => {
                this.initView()
                this.$emit('mounted', this.$refs.map)
                this.$emit('mapReady', this.map)
            })
        },
        initView: function () {
            if (this.map) {

                // Clear existing markers/polylines first
                if(this.forceRemovePreviousGeometry) {
                    this.clearAllMapItems()
                }
                if (this.points && this.points.length > 0) {
                    this.drawLineString()
                } else {
                    this.drawPoint()
                    this.$nextTick(() => this.$refs.map?.getMap().zoomToPosition(this.lat, this.lon, 17))
                    // Stupid hack to ensure all markers appear on the map
                    setTimeout(() => this.$refs.map?.getMap().zoomToPosition(this.lat, this.lon, 16), 1000)
                }
            }
        },

        clearAllMapItems: function() {
            if (!this.map) {
                return
            }
            // Try multiple removal approaches
            this.map.removeMapMarker(this.id, this.type);
            this.map.removePolyline(this.id, this.type);

            // Also try removing by type entirely if ID-based removal fails
            this.map.removeMapMarkerByType(this.type);
            this.map.removePolylinesByType(this.type);

            // Force remove all items if the above don't work
            if (this.observationMode) {
                this.map.removeMapItemsByType(this.type);
            }
        },

        draw() {
            if (this.map) {
                if (this.points && this.points.length > 0) {
                    if (this.observationMode) {
                        this.map.removeMapMarker(this.id, this.type)
                        if (this.points.length > 0) {
                            let firstPoint = this.points[0]
                            this.map.zoomToPosition(firstPoint.y, firstPoint.x, 17)
                        }
                    }
                    this.drawLineString()
                } else {
                    if (this.observationMode) {
                        this.map.removePolyline(this.id, this.type)
                        this.map.zoomToPosition(this.lat, this.lon, 17)
                    }
                    this.drawPoint()
                }
            }
        },

        updatePoint() {
            if (!this.map) {
                return
            }
            this.clearAllMapItems()
            this.drawPoint()
        },

        drawPoint: function () {
            if (this.type > 0){
                this.map.showMapMarker(this.id, this.type, this.lat, this.lon, this.getMarker(), this.draggable)
                this.$nextTick(() =>  {
                    this.map.zoomToPosition(this.lat, this.lon, 17)
                    this.map.resizeMap()
                })
            }
        },

        drawLineString: function () {
            this.map.drawPolyLine(this.id, this.type, this.points, '#bb330e', false, false, 4, 1, true)
            this.$nextTick(() =>  {
                this.map.zoomToGroup(this.type, this.map.getMapZoomLevel()-1)
                this.map.resizeMap()
            })
        },

        getMarker: function () {
            if (this.type) {
                let markerStore = this.map.getMarkerStore()
                switch (this.type) {
                    case this.OBSERVATION:
                        return markerStore.getObservationMarkerIcon()
                    case this.EQUIPMENT:
                        return markerStore.getEquipmentMarkerIcon()
                    case this.MATERIAL_STORAGE:
                        return markerStore.getStorageMarkerGenericIcon()
                    case this.BRIDGE:
                        return markerStore.getSvgMarker(bridgeSvg, null, null, '2.7em', '2.7em')
                    case this.CULVERT:
                        return markerStore.getCulvertIcon()
                    case this.VEHICLE:
                        return this.getVehicleMarker(this.vehicleType, this.fresh, markerStore)
                    default:
                        return null
                }
            }
            return undefined
        },

        onDragMarker: function (location) {
            this.$emit('onDragMarker', location.position)
        },
        onMapClicked: function (location) {
            this.$emit('onMapClicked', location)
        },
        addLayer: function (layer){
            this.map.addLayer(layer);
        },

    }
}
</script>
